export const MY_SALES_TABS = {
  OVERVIEW: 0,
  PRODUCTS: 1,
  PERSONAL_VIDEOS: 2,
  PERSONAL_VIDEO_REQUESTS: 3,
  STREAMS: 4,
  EXPERIENCES: 5,
  MY_TIPS: 6,
} as const;
